import InvocieList from "views-main-account/AllInvoices/AllInvoices";
import AllPdfView from "views-main-account/AllInvoices/PdfView";
import AppointmentList from "views-main-account/AppointmentList";
import Dashboard from "views-main-account/Dashboard";
import Profile from "views-main-account/profile";
import ChangePassword from "views/ChangePassword";

import AddClientTranslatoinForm from "views-main-account/ClientTranslation/AddClientTranslatoinForm";
import ClientTranslation from "views-main-account/ClientTranslation/ClientTranslation";
import ClientTranslationView from "views-main-account/ClientTranslation/ClientTranslationView";

var routesMainAccounts = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Dashboard />,
    layout: "/user",
  },
  {
    path: "/translation/create",
    subRoute: true,
    component: <AddClientTranslatoinForm />,
    layout: "/user",
  },
  {
    path: "/appointments",
    title: "Appointments",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <AppointmentList />,
    layout: "/user",
  },
  {
    path: "/translation",
    title: "Translations",
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <ClientTranslation />,
    layout: "/user",
  },
  {
    path: "/translation/view/:id",
    subRoute: true,
    component: <ClientTranslationView />,
    layout: "/user",
  },
  {
    path: "/invoices",
    title: "Invoices",
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component: <InvocieList />,
    layout: "/user",
  },
  {
    path: "/invoices/pdf-view/:id",
    subRoute: true,
    component: <AllPdfView />,
    layout: "/user",
  },
  {
    path: "/profile",
    subRoute: true,
    component: <Profile />,
    layout: "/user",
  },
  {
    path: "/change-password",
    subRoute: true,
    component: <ChangePassword />,
    layout: "/user",
  },
];
export default routesMainAccounts;
